import { Routes } from '@angular/router';
import { IsAuthenticatedGuard } from './core/guard/is-authenticated.guard';
import { IsAnonymousGuard } from './core/guard/is-anonymous.guard';

export const routes: Routes = [
    {
        path: 'permission-groups',
        canLoad: [IsAuthenticatedGuard],
        loadChildren: () =>
        import('./features/group-permission/group-permission.module')
            .then((m) => m.GroupPermissionModule)
            .catch((err) => {
            console.error('Group Permission module Error', err);
            throw err; // <- important
            }),
    },
    {
        redirectTo: 'login',
        pathMatch: 'full',
        path: '',
    },
    {
    path: 'user',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/user/user.module')
        .then((m) => m.UserModule)
        .catch((err) => {
          console.error('User module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'operators',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/operators/operators.module')
        .then((m) => m.OperatorsModule)
        .catch((err) => {
          console.error('Operators module Error', err)
          throw err; // <- important
        }),
  },
  {
    path: 'group',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/portal-group/portal-group.module')
        .then((m) => m.PortalGroupModule)
        .catch((err) => {
          console.error('Portal group module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'molding-orders',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/molding-orders/molding-orders-module')
        .then((m) => m.MoldingOrdersModule)
        .catch((err) => {
          console.error('Molding Orders module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'molding-press',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/molding-press/molding-press-module-module')
        .then((m) => m.MoldingPressModule)
        .catch((err) => {
          console.error('Molding Press module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'pallet',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/pallets/pallets-module')
        .then((m) => m.PalletsModule)
        .catch((err) => {
          console.error('Pallets module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'molding-jobs',
    canLoad: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/molding-jobs/molding-jobs-module-module')
        .then((m) => m.MoldingJobsModule)
        .catch((err) => {
          console.error('Molding Press module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'login',
    canLoad: [IsAnonymousGuard],
    loadChildren: () =>
      import('./features/login/login.module')
        .then((m) => m.LoginModule)
        .catch((err) => {
          console.error('Login module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: 'home-page',
    canActivate: [IsAuthenticatedGuard],
    loadChildren: () =>
      import('./features/home-page/home-page.module')
        .then((m) => m.HomePageModule)
        .catch((err) => {
          console.error('Home module Error', err);
          throw err; // <- important
        }),
  },
  {
    path: '**',
    redirectTo: 'molding-orders',
    pathMatch: 'full',
  },
];
